import { useState, useRef, useContext, useEffect } from "react";
import "./style.css"

function Loader() {
    return (
        <div class="loader"></div>
    )
}
export default Loader;